const defaultClients = [
  {
    clientId: "5d9cc1f61c9d44000017db96",
    name: "ClickPrinting",
    logo: "https://content.click2printsolutions.com/editor/2d91a63b-1892-4206-a799-f36d71f59147loco.svg"
  },
  {
    clientId: "5fdb4f258667d09c9dd7fb05",
    name: "ClickPrinting Fr",
    logo: "https://content.click2printsolutions.com/editor/ca1eedb2-491d-4e7d-aad2-6f64ab600386click.svg"
  },
  {
    clientId: "5fa2dbc966911e7087a458c8",
    name: "Oedim",
    logo: "https://content.click2printsolutions.com/editor/164ff117-b2d1-4a49-b7ef-c769c49e4d11oedim-logotipo.svg"
  },
  {
    clientId: "61e55242caa54e057ddf42ea",
    name: "Todolonas",
    logo: "https://content.click2printsolutions.com/editor/todolonas-1dedb.svg"
  },
];

export default defaultClients;
